/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

import React, { Component } from 'react'
import { Input, Form, Icon, Popup } from 'semantic-ui-react'
import SemanticDatepicker from 'react-semantic-ui-datepickers'
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css'
import _ from 'lodash'
import {propsAreEqual_NoRerenderNeeded} from '../reducer/util'

export class InputField extends Component {
  constructor() {
    super();
    this.state = {
      wasFocused: false,
      wasChanged: false,
      clearTextSpinner: false
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.newValue !== this.state.newValue ||
      nextProps.rbCounterId !== this.state.rbCounterId
    ) {
      this.setState(
        { newValue: nextProps.newValue, rbCounterId: nextProps.rbCounterId },
        () => {
          this.props.fieldName === this.props.id + this.props.shipmentId &&
            this.props.onChange(
              this.props.isInteger
                ? parseFloat(
                  this.state.newValue.replace(/[^\d.-]/g, '')
                ).toFixed(2)
                : this.state.newValue
            )
        }
      )
    }
  }

  shouldComponentUpdate(nextProps, nextState){
    if(window.slowstate)return true;
    return this.state.isFocused || !propsAreEqual_NoRerenderNeeded(this.props,nextProps) || !propsAreEqual_NoRerenderNeeded(this.state,nextState) || ((nextState.currentValueRerenderer||0)+25000>Date.now());

  }
  
  errorPopup = errors => {
    const error = errors.map((info, index) => {
      return (
        <div className='error' key={index}>
          * {info}
        </div>
      )
    })
    return (
      <Popup trigger={<Icon name='warning sign' color='red' />} content={error || ''} />
    )
  }

  warningPopup = warnings => {
    const warning = warnings.map((info, index) => {
      return (
        <div className='error' key={index}>
          * {info}
        </div>
      )
    })
    return (
      <Popup trigger={<Icon name='warning sign' color='yellow' />} content={warning || ''} />
    )
  }

  emptyField = id => {
    this.setState({clearTextSpinner:true})
    setTimeout(()=>{
      !this.props.isInteger && this.props.onChange('')
      let element = document.getElementById(id)
      element && element.focus()
      this.setState({clearTextSpinner:false})
    },1000)
  }
  render() {
    const {
      id,
      dateClass,
      subLabelText,
      subLabelToFixed,
      iconPosition,
      label,
      width,
      isLabel,
      className,
      type,
      onChange,
      icon,
      subLabelClass,
      onBlur,
      disabled,
      value,
      labelClassName,
      setINPUTID,
      penClicked,
      isInteger,
      shipmentId,
      handleFocus,
      labelIcon,
      clearInput,
      maxlength,
      errors,
      warnings,
      postLabel,
      onKeyUp,
      filterDate,
      minDate,
      maxDate,
      showToday,
      saveOnTabOut
    } = this.props
    const {
      clearTextSpinner
    } = this.state;
    let redBgColor = "";
    let yellowBgColor = "";
    if(warnings && warnings.length){
      yellowBgColor = "yellowBgColor";
    }
    if(errors && errors.length){
      redBgColor = "redBgColor";
    }
    
    return (
      <React.Fragment>
        {type !== 'date' && (
          <label
            htmlFor={id + shipmentId}
            style={{cursor:disabled?'not-allowed':'text'}}
            className={
              labelClassName
                ? 'name-label es ' + labelClassName
                : 'name-label es'
            }
          >
            {(errors && errors.length) ? this.errorPopup(errors) : ''}
            {(warnings && warnings.length) ? this.warningPopup(warnings) : ''}
            {label}
            {labelIcon && labelIcon}
          </label>
        )}
        <Form.Field onClick={()=>{this.setState({wasFocused:true})}} className={dateClass + ' date-field '+'subclass-'+subLabelClass+' '+redBgColor+yellowBgColor} width={width}>
          {isLabel && <label size='small'> {label} </label>}
          {type === 'date' && labelIcon}
          {type === 'date' ? (<React.Fragment key={this.state.currentValueRerenderer}>
            <SemanticDatepicker
              name={id}
              id={id + shipmentId}
              //there's a bug with the semantic datepicker library that can causes it to run onchange when it first loads, which is really bad. The time condition prevents this
              clearable={this.state.wasFocused}
              onDateChange={value => {
                if(onChange && this.state.wasFocused && (!this.state.lastSaveHS?.getTime() || this.state.lastSaveHS?.getTime()!=value?.getTime())){
                  this.setState({lastSaveHS : value});
                  if(!filterDate || filterDate(value)){
                    onChange(value, value) && this.setState({currentValueRerenderer:Date.now()})
                  }  else {
                    onChange(null, null) && this.setState({currentValueRerenderer:Date.now()})
                    
                  }
                }
                this.setState({currentValueRerenderer:Date.now()});
              }}
              selected={(value !== -999 && value > 0 && value !== undefined) ? new Date(new Date(value)) : false}
              onBlur={event => onBlur && onBlur(new Date(event.target.value))}
              onFocus={()=>{this.setState({wasFocused:true})}}
              pointing={'left'}
              filterDate={filterDate}
              showToday={this.props.hasOwnProperty("showToday") === true ? showToday : true}
              minDate={minDate}
              maxDate={maxDate}
              className={className+" "+redBgColor+ yellowBgColor}
              label={<label className='floating-date-label'> {(errors && errors.length) ? this.errorPopup(errors) : ''} {label}</label>}
              icon='calendar outline'
              format='MM/DD/YYYY'
              disabled={disabled}
              clearOnSameDateClick={false}
            />
          </React.Fragment>) : (
          
              <Input
              className={redBgColor || yellowBgColor}
                value={(value) === '_BLANK_' ? '' : 
                  (value)
                  }
                width={width}
                iconPosition={iconPosition}
                id={id + shipmentId}
                name={id + shipmentId}
                type={type}
                title={value}
                placeholder={this.props.placeholder}
                onChange={event => {
                  onChange(event.target.value)//NOTE: This must be the first thing, otherwise the state will change with the value not being updated yet
                  setTimeout(()=>{
                    this.setState({focusValueX:event.target.value, isFocused:true, wasChanged:true,currentValueRerenderer:Date.now()});
                  },0);
                }}
                onBlur={event => {
                  this.setState({isFocused:false})
                  if(!this.state.wasChanged && !saveOnTabOut && value == this.state.focusValueX)return;
                  if (isInteger && !event.target.value) {
                    onChange('0.00')
                  }
                  onBlur && onBlur(event.target.value)
                  this.setState({currentValueRerenderer:Date.now()})
                  this.setState({wasChanged:false});
                }}
                onKeyUp={e =>{
                  onKeyUp && onKeyUp(e)
                  this.setState({currentValueRerenderer:Date.now()})
                }}
                disabled={disabled}
                onMouseDown={e => {
                  e.stopPropagation()
                  penClicked && penClicked(e)
                }}
                onFocus={event => {
                  if(this.state.focusInited && this.state.focusValueX !=  value){
                    this.setState({ wasChanged:true });
                  }
                  this.setState({focusValueX:value,focusInited:true,isFocused:true,currentValueRerenderer:Date.now()})
                  event.target && event.target.setAttribute("autocomplete", "nope");
                  handleFocus && handleFocus(event)
                  setINPUTID && setINPUTID(id + shipmentId)
                }}
              >
                <input
                  maxLength={maxlength}
                  className={className + ' form-control ' + ` subLabelLength${subLabelText?.length} `}
                />
                {['C$','$'].includes(subLabelText) && !!parseFloat(value) && 
                  <div type="text" className={`moneyDisplayerOverlay length${subLabelText.length}`}>{parseFloat(value).toFixed(subLabelToFixed || 2).toLocaleString('us-US', { style: 'currency', currency: 'USD' }).replaceAll("$","")}</div>
              }
              {this.props.extraPunctuation && this.props.extraPunctuation.includes("zipCodeUnitedStatesx") && value?.length > 5 &&
                  <div type="text" className={`moneyDisplayerOverlay length0`} style={{fontSize:'1rem'}}>
                  {value?.substring(0,5)+"-"+value?.substring(5,90)}
                    </div>
              
              }
                {icon}
                {subLabelText && <p className={subLabelClass}>{subLabelText}</p>}
                {postLabel && !disabled && <p className='right-icon'>{postLabel}</p>}
                {clearInput && (
                  <Icon
                    className={(clearTextSpinner?' minispinner ':'')+' delete-field-icon '}
                    name={clearTextSpinner?'spinner':'close'}
                    style={{width:'20px',height:'20px'}}
                    inverted
                    disabled={clearTextSpinner}
                    link
                    id='delete-text'
                    onClick={() => {
                      this.setState({wasChanged:true});
                      !this.props.disabled && this.emptyField(id + shipmentId) && this.setState({currentValueRerenderer:Date.now()})
                    }}
                  />
                )}
              </Input>
            )}
        </Form.Field>
      </React.Fragment>
    )
  }
}

export default InputField
